module.exports = __webpack_public_path__ + "img/selected7-min.fa9185f2.png";